import { Icon, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import _ from 'lodash'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useEditSectionContext } from '../../feat/editItinerary/editSectionProvider'
import { useBoundStore } from '../../state/bound.store'
interface IListHeaderProps {
    id?: string
    data: any
    renderOptions: IListHeaderOptions
}

interface IListHeaderOptions {
    listFieldId: number
    fieldToDisplayId?: number
    icon?: string
    fallbackText?: string
}
export const ListHeader = ({ id, data, renderOptions }: IListHeaderProps) => {
    const { getFieldById } = useBoundStore(
        useShallow((s) => {
            return {
                getFieldById: s.getFieldById,
            }
        })
    )
    const { getValue } = useEditSectionContext()

    const field = useMemo(() => {
        return getFieldById(renderOptions.listFieldId)
    }, [renderOptions.listFieldId, getFieldById])

    const keyFieldValues = useMemo(() => {
        if (renderOptions.fieldToDisplayId) {
            const fieldToDisplay = getFieldById(renderOptions.fieldToDisplayId)
            return fieldToDisplay ? [getValue(fieldToDisplay, data._id)] : []
        }
        const keyFieldsIDs = field?.type_properties?.key_fields ?? []

        const keyFields = keyFieldsIDs.map((keyFieldId: any) => {
            return getFieldById(keyFieldId)
        })
        return keyFields.map((keyField: any) => {
            return getValue(keyField, data._id, true)
        })
    }, [
        field,
        getValue,
        data._id,
        renderOptions.fieldToDisplayId,
        getFieldById,
    ])

    const firstKeyFieldValue = useMemo(() => {
        let resp = ''
        if (_.isArray(keyFieldValues[0])) {
            resp = keyFieldValues[0].join(', ')
        } else {
            resp = keyFieldValues[0] ?? ''
        }

        if (resp.length > 1) {
            return resp
        }
        return renderOptions.fallbackText ?? ''
    }, [keyFieldValues, renderOptions.fallbackText])

    return (
        <Stack direction={'row'} spacing={'16px'}>
            {renderOptions.icon && <Icon name={renderOptions.icon as any} />}
            <Typography
                id={`${id}booking-ref-text`}
                noWrap
                overflow={'hidden'}
                textOverflow={'ellipsis'}
                maxWidth={'calc(100vw - 150px)'}
                variant={'bodyBold'}
            >
                {firstKeyFieldValue}
            </Typography>
        </Stack>
    )
}
